/**
 * Estado de auth accesible sincrónicamente desde la capa de datos (para el logging
 * de errores de los services, que antes leían auth.currentUser de Firebase).
 * Lo mantiene actualizado el AuthProvider (FirebaseProvider.tsx).
 */
export interface AuthUserInfo {
  uid: string;
  email: string | null;
}

let current: AuthUserInfo | null = null;

export const setAuthUser = (user: AuthUserInfo | null): void => {
  current = user;
};

export const getAuthUser = (): AuthUserInfo | null => current;
